import React from 'react';
// Background provided by ScrollBackground

const services = [
  {
    title: 'Corporate Advisory',
    description:
      'Advisory to founders and executive teams on enterprise positioning, structural clarity, and long-term value architecture.',
    icon: 'corporate',
  },
  {
    title: 'Transaction Optimization',
    description:
      'Engineering commercial transactions for certainty, sequencing, and disciplined execution across mandates.',
    icon: 'transaction',
  },
  {
    title: 'Cross-Border Structuring',
    description:
      'Jurisdictional coordination across Canada, Singapore, and global markets to align governance, operations, and growth.',
    icon: 'crossborder',
  },
  {
    title: 'Commercial Structuring',
    description:
      'Framework development for pricing, contractual alignment, risk mapping, and value capture.',
    icon: 'commercial',
  },
  {
    title: 'Trade & Project Coordination',
    description:
      'Non-regulated trade structuring and execution choreography across supply chains, projects, and counterparties.',
    icon: 'trade',
  },
  {
    title: 'Enterprise Growth Strategy',
    description:
      'Strategic repositioning and scalable expansion planning across vertical and horizontal initiatives.',
    icon: 'growth',
  },
  {
    title: 'Executive Negotiation Support',
    description:
      'Alignment advisory for partner discussions, governance negotiations, and strategic transaction frameworks.',
    icon: 'negotiation',
  },
  {
    title: 'Ecosystem Coordination',
    description:
      'Working alongside licensed investment banks, legal counsel, regulated brokers, and accounting firms when execution requires licensed oversight.',
    icon: 'ecosystem',
  },
];

const ServiceIcon = ({ type }) => {
  const iconClass = 'w-10 h-10 md:w-12 md:h-12 text-navy-800/70';

  switch (type) {
    case 'corporate':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <rect x="14" y="8" width="20" height="34" rx="1" />
          <rect x="18" y="14" width="4" height="4" rx="0.5" />
          <rect x="26" y="14" width="4" height="4" rx="0.5" />
          <rect x="18" y="22" width="4" height="4" rx="0.5" />
          <rect x="26" y="22" width="4" height="4" rx="0.5" />
          <rect x="18" y="30" width="4" height="4" rx="0.5" />
          <rect x="26" y="30" width="4" height="4" rx="0.5" />
          <rect x="21" y="36" width="6" height="6" />
          <line x1="6" y1="42" x2="42" y2="42" />
        </svg>
      );
    case 'transaction':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <polyline points="6,36 16,24 24,30 36,14 42,8" />
          <polyline points="36,8 42,8 42,14" />
          <line x1="6" y1="42" x2="42" y2="42" />
          <line x1="6" y1="8" x2="6" y2="42" />
        </svg>
      );
    case 'crossborder':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="24" cy="24" r="16" />
          <ellipse cx="24" cy="24" rx="8" ry="16" />
          <line x1="8" y1="24" x2="40" y2="24" />
          <path d="M10 16 h28" />
          <path d="M10 32 h28" />
        </svg>
      );
    case 'commercial':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <rect x="10" y="6" width="22" height="30" rx="2" />
          <line x1="16" y1="14" x2="26" y2="14" />
          <line x1="16" y1="20" x2="26" y2="20" />
          <line x1="16" y1="26" x2="22" y2="26" />
          <path d="M26 32 L38 44" strokeWidth="2" />
          <path d="M22 36 L38 36 L38 44 L22 44 Z" />
        </svg>
      );
    case 'trade':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M8 36 L8 20 L16 14 L24 20 L24 36" />
          <path d="M24 36 L24 20 L32 14 L40 20 L40 36" />
          <line x1="4" y1="36" x2="44" y2="36" />
          <rect x="12" y="24" width="4" height="6" />
          <rect x="32" y="24" width="4" height="6" />
        </svg>
      );
    case 'growth':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <rect x="6" y="30" width="8" height="12" rx="1" />
          <rect x="17" y="22" width="8" height="20" rx="1" />
          <rect x="28" y="14" width="8" height="28" rx="1" />
          <polyline points="30,10 40,6 42,6" strokeWidth="2" />
          <polyline points="38,10 40,6 44,6" />
        </svg>
      );
    case 'negotiation':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="16" cy="16" r="6" />
          <circle cx="32" cy="16" r="6" />
          <path d="M4 38 C4 30 10 26 16 26" />
          <path d="M44 38 C44 30 38 26 32 26" />
          <path d="M18 26 Q24 32 30 26" />
        </svg>
      );
    case 'ecosystem':
      return (
        <svg
          className={iconClass}
          viewBox="0 0 48 48"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle cx="24" cy="24" r="4" />
          <circle cx="24" cy="8" r="3" />
          <circle cx="24" cy="40" r="3" />
          <circle cx="10" cy="16" r="3" />
          <circle cx="38" cy="16" r="3" />
          <circle cx="10" cy="32" r="3" />
          <circle cx="38" cy="32" r="3" />
          <line x1="24" y1="11" x2="24" y2="20" />
          <line x1="24" y1="28" x2="24" y2="37" />
          <line x1="13" y1="17" x2="21" y2="22" />
          <line x1="27" y1="22" x2="35" y2="17" />
          <line x1="13" y1="31" x2="21" y2="26" />
          <line x1="27" y1="26" x2="35" y2="31" />
        </svg>
      );
    default:
      return null;
  }
};

const ServiceCard = ({ title, description, icon, delay }) => (
  <div
    className="service-card bg-cream-100 rounded-lg p-5 md:p-6 border border-cream-200/50 shadow-md"
    data-aos="fade-up"
    data-aos-delay={delay}
  >
    <div className="mb-3">
      <ServiceIcon type={icon} />
    </div>
    <h3 className="font-serif text-base md:text-lg font-bold text-navy-900 mb-2 border-b border-navy-900/20 pb-1">
      {title}
    </h3>
    <p className="text-sm md:text-base text-navy-900/70 leading-relaxed font-body">
      {description}
    </p>
  </div>
);

const WhatWeDo = () => {
  return (
    <section id="services" className="relative">
      {/* Header area — transparent to show scroll background */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-white/60" />

        <div className="relative z-10 text-center py-12 md:py-16 lg:py-20 px-6">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 tracking-wide mb-2">
            <span className="border-b-2 border-navy-900/30 pb-1">
              WHAT WE DO
            </span>
          </h2>
          <p className="font-serif text-lg md:text-xl lg:text-2xl text-navy-900/80 italic mt-6 mb-2">
            Transaction Architecture &amp; Commercial Structuring
          </p>
          <p className="font-body text-base md:text-lg text-navy-900/60 italic tracking-wide">
            Advisory-Only. Strategic. Independent.
          </p>
        </div>
      </div>

      {/* Cards section */}
      <div className="dark-section py-12 md:py-16 px-4 md:px-8 lg:px-12">
        <h3 className="font-serif text-2xl md:text-3xl text-gold-400 text-center mb-8 md:mb-12 border-b border-gold-500/30 pb-4 max-w-md mx-auto">
          What We Do
        </h3>

        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              {...service}
              delay={index * 100}
            />
          ))}
        </div>

        <p className="text-center text-cream-300/60 text-xs md:text-sm mt-8 md:mt-12 max-w-3xl mx-auto italic font-body">
          Marquee operates strictly as an independent corporate advisory
          platform. All regulated securities activity is performed by duly
          licensed third-party professionals.
        </p>
      </div>
    </section>
  );
};

export default WhatWeDo;
